import { CARRIERS } from "@/lib/carriers";

type Props = {
  value: string;
  onChange: (code: string) => void;
  id?: string;
  className?: string;
  includeNone?: boolean;
};

export function CarrierSelect({ value, onChange, id, className, includeNone }: Props) {
  return (
    <select
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={
        className ??
        "h-10 w-full rounded-md border border-border bg-panel px-3 text-sm focus:border-primary focus:outline-none"
      }
    >
      {includeNone && <option value="">No preference</option>}
      {CARRIERS.map((c) => (
        <option key={c.code} value={c.code}>
          {c.name}
        </option>
      ))}
    </select>
  );
}
